module.exports = __webpack_public_path__ + "static/headshot-39776274525f7807039a2d702b5552e7.jpg";